import { Helmet } from "react-helmet-async"
import { MailMessagesList } from "../../MailMessages"

export default function MailMessagesPage() {
	return (
		<>
			<Helmet>
				<title>Mail Messages</title>
			</Helmet>
			<MailMessagesList />
		</>
	)
}
